import { Image, Avatar, Box,  Divider, Flex, Heading, Text, Card, CardBody, TableContainer, Table, Thead, Tr, Th, Tbody, Td} from '@chakra-ui/react'

import ralco_logo from './ralco_logo.png'
import { ToWords } from 'to-words';
import { useState } from 'react';
const OrderInvoice = ({orderData, tenureData, getInvoice, rentalInvoice}) => {
    const [finalAmountCalObj] = useState(JSON.parse(sessionStorage.getItem('invoiceTotalFinal')))
    const toWords = new ToWords();
    let price = 0
    let orderAmount = ""


       // ---- set price for price input value ---
   // Total Item Price Caluculation
   const endDateCalculation = (date, duration, typeOfTenure) => {
    // Define the start date and duration
    const startDate = new Date(date);
    const durationDays =
      typeOfTenure === "weekly" ? duration * 7 : duration * 30;
    // Weekly Calculation Condition - if block
    if (typeOfTenure === "weekly" && duration > 0) {
      // Calculate the end date of week
      let endDate = new Date(
        startDate.getTime() + (durationDays - 1) * 24 * 60 * 60 * 1000
      );
      const endDateObj = new Date(endDate);
      endDate = `${endDateObj.getDate()}/${endDateObj.toLocaleString(
        "default",
        { month: "short" }
      )}/${endDateObj.getFullYear()}`;
      // Weekly days * amount
      orderAmount = (calculateNoOfDays(endDate, startDate));
      return endDate;
      // Monthly Calculation Condition - else block
    } else if(typeOfTenure === "monthly" && duration > 0) {
   
      // Calculate the end date of month
      let endDate = new Date(startDate.getTime() + durationDays * 24 * 60 * 60 * 1000);

      // Set the end date to the last day of the month
      endDate.setMonth(endDate.getMonth());
      endDate.setDate(0);

      // Format the end date
      const endDateMonth = `${endDate.getDate()}/${endDate.toLocaleString("default", {
        month: "short"
      })}/${endDate.getFullYear()}`;
      orderAmount = (remainingDaysInMonth(new Date(date)));
      return endDateMonth;
    } else {
      return ;
    }
    
  };

   // Calculate the number of days in weekly
   const calculateNoOfDays = (endDate, startDate) => {
    const timeDiff =
      new Date(endDate).getTime() - new Date(startDate).getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return (diffDays + 1) * price;
  };
// Calculate the number of remaining days in month
const remainingDaysInMonth = (date) => {
  const year = date.getFullYear();
  // const month = date.getMonth() + 1;
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const numDaysInMonth = new Date(year, month, 0).getDate();
  let remainingDays = numDaysInMonth - day;
  // console.log(remainingDays + 1, '55555555555555555555')
  remainingDays += 1
  return remainingDays * price;
};



  return (
    <Box>
        <Box border={'1.5px solid #E9E8E8'} borderRadius={'10px'} mt={3} >
            <Box p={4}>
                <Flex>
                    <Flex flexBasis={'80%'}>
                        <Text fontSize={25} fontWeight={'semibold'} mt={"2px"}>Rental Invoice&nbsp;</Text>
                        <Text fontSize={24} fontWeight={'normal'}> - {rentalInvoice}</Text>
                    </Flex>  
                    <Flex flexBasis={"20%"} alignItems={'center'} justifyContent={'flex-end'}>
                        <Text fontSize={11}>{
                        (new Date(getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE").invoiceDate).toLocaleString('en-IN', {
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            hour12: true
                                            })).toUpperCase()}
                        </Text>
                    </Flex>     
                </Flex>
                <Divider mt={3} mb={3} color={'#E9E8E8'} borderWidth="1.3px"/>
                {/* logo part */}
                <Flex >
                    <Flex alignItems={'center'} flexBasis={'65%'}>
                         <Image
                            boxSize='75px'
                            objectFit='fit'
                            src={ralco_logo}
                            alt='logo'
                            mt={'5px'}
                        />
                        <Box ml={2}>
                                <Heading p={1} fontSize={26} fontWeight={'semibold'}>Equipp Synergy Pvt Ltd</Heading>
                                <Box pl={1} pr={1}>
                            <Flex>
                                <Heading fontSize={16} fontWeight={'semibold'} mt={'2px'}>CIN Number&nbsp;</Heading>
                                <Text wordBreak={'break-all'}> : U72900KA2022PTC165644</Text>
                            </Flex>
                            <Flex>
                                <Heading fontSize={16} fontWeight={'semibold'} mt={'2px'}>GSTIN&nbsp;</Heading>
                                <Text wordBreak={'break-all'}> : 29AAHCE2227R1Z3</Text>
                            </Flex>
                            </Box>
                        </Box>  
                    </Flex>
                    <Flex flexBasis={'35%'} flexDirection={'column'} >
                            <Flex wrap={'wrap'}>
                            <Flex>
                                <Heading fontSize={16} fontWeight={'semibold'} mt={'2px'}>State&nbsp;</Heading>
                                <Text wordBreak={'break-all'}> : Karnataka ||&nbsp;</Text>
                            </Flex>
                            <Flex>
                                <Heading fontSize={16} fontWeight={'semibold'} mt={'2px'}>State Code&nbsp;</Heading>
                                <Text wordBreak={'break-all'}> : 29&nbsp;</Text>
                            </Flex>
                            <Flex>
                                <Heading fontSize={16} fontWeight={'semibold'} mt={'2px'}>City&nbsp;</Heading>
                                <Text wordBreak={'break-all'}> : Bangalore</Text>
                            </Flex>
                            </Flex>
                            <Flex >
                                <Heading fontSize={16} fontWeight={'semibold'} mt={'2px'} lineHeight={'22px'}>Address&nbsp;
                                <Text as="span" fontWeight={'normal'}> : Equipp Synergy Pvt Ltd. #13, 1st stage, 1st block, Sri Rama Temple Road, HBR Layout, Bangalore – 560043
                                </Text>
                                </Heading>
                               
                            </Flex>
                    </Flex>
                </Flex>
                {/* Invoice details */}
                <Card bgColor={'blackAlpha.50'} mt={5} style={{ pageBreakInside: 'avoid' }}>
                    <CardBody>
                        <Flex>
                            <Box flexBasis={'60%'}>
                                <Text fontSize={25} fontWeight={'semibold'} mb={2}>Invoice Details</Text>
                                <Flex>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}>Invoice ID&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>{getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE").statusId === "PAID" ? getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE").invoiceIdentifier : getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE").invoiceName }</Text>
                                </Flex>
                                <Flex mt={2}>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}>Invoice Date&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>{new Date(getInvoice.find((x) => x.invoiceTypeId === "ORDER_INVOICE").invoiceDate).toLocaleDateString('en-IN')}</Text>
                                </Flex>
                                <Flex mt={2}>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}>Base Price&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>₹{finalAmountCalObj?.totalItemPrice.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                                </Flex>
                                <Flex mt={2}>
                                    <Heading flexBasis={'45%'}fontSize={17} fontWeight={'semibold'}>Tenure Discount&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>₹{finalAmountCalObj?.totalDiscount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                                </Flex>
                               
                                <Flex mt={2}>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}>Subtotal&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>₹{finalAmountCalObj?.subTotal.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                                </Flex>
                                <Flex mt={2}>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}>Total Tax&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>₹{finalAmountCalObj?.totalTax.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                                </Flex>
                                {/* <Flex mt={2}>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}>Total Security Deposit&nbsp;</Heading>
                                    <Text flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'}>₹{finalAmountCalObj?.totalDeposit.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                                </Flex> */}
                                <Flex mt={1}>
                                    <Heading flexBasis={'45%'} fontSize={17} fontWeight={'semibold'}> GST Number&nbsp;</Heading>
                                    <Text mt={'6px'} flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'} >{orderData.orderGstNumber !== null ? orderData.orderGstNumber : 'n/a'}</Text>
                                </Flex>
                                <Flex mt={1}>
                                    <Heading flexBasis={'45%'} fontSize={24} fontWeight={'semibold'} mt={'4px'}>Net Payable&nbsp;</Heading>
                                    <Text mt={'6px'} flexBasis={'10%'}> : </Text>
                                    <Text flexBasis={'45%'} fontSize={24} fontWeight={'bold'} color={"gray.600"}>₹{(finalAmountCalObj?.subTotal + finalAmountCalObj?.totalTax).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                                </Flex>
                            </Box>
                            <Flex flexBasis={'40%'} alignItems={'left'} flexDirection={'column'} >
                            <Text fontSize={25} fontWeight={'semibold'} textAlign={'right'} mb={2}>Billed to</Text>
                            <Text textAlign={'right'} wordBreak={'break-all'}>{orderData.customerParty?.firstName + ' ' + orderData.customerParty?.lastName}</Text>
                            <Text textAlign={'right'} wordBreak={'break-all'}>{orderData.customerParty?.phone}</Text>
                            <Text textAlign={'right'} as="span" >
                                {orderData.shippingAddress?.addressline1 + ", " + orderData.shippingAddress?.city + ", " + orderData.shippingAddress?.state + ", " + orderData.shippingAddress?.country + ", " + orderData.shippingAddress?.pincode}
                            </Text>                          
                            </Flex>
                        </Flex>
                    </CardBody>
                </Card>
                {/* Invoice Items(s) Details */}
                <Box mt={5} >
                <Text fontSize={25} fontWeight={'semibold'} mb={2}>Invoice Item(s) Details</Text>
                    <TableContainer >
                        <Table variant='unstyled' >
                            <Thead  borderBottom={'1px solid #eef1f6'} style={{ pageBreakInside: 'avoid' }}>
                                <Tr>
                                    <Th fontSize={'10px'} px={1} color={"gray.600"}>S.No</Th>
                                    <Th fontSize={'10px'} pl={1} color={"gray.600"} >Particulars</Th>
                                    <Th fontSize={'10px'} px={2} pl={2} color={"gray.600"}>Base Price</Th>
                                    <Th fontSize={'10px'} px={2} color={"gray.600"}>Tenure <br/>Discount</Th>
                                    {/* <Th fontSize={'10px'} px={2} color={"gray.600"}>Late <br/>Fees</Th> */}
                                    <Th fontSize={'10px'} px={2} color={"gray.600"}>Total <br/>Tax</Th>
                                    <Th fontSize={'10px'} px={2} color={"gray.600"} textAlign={'center'}>IGST</Th>
                                    <Th fontSize={'10px'} px={2} color={"gray.600"} textAlign={'center'}>CGST</Th>
                                    <Th fontSize={'10px'} px={2} color={"gray.600"} textAlign={'center'}>SGST</Th>
                                    {/* <Th fontSize={'10px'} px={2} color={"gray.600"}>Subtotal</Th> */}
                                    {/* <Th fontSize={'10px'} px={2} color={"gray.600"}>Security <br/>Deposit</Th> */}
                                    <Th fontSize={'10px'} px={2} pr={0} textAlign={'right'} color={"gray.600"}>Net <br/>Payable</Th>
                                </Tr>
                            </Thead>
                            {/* Body */}
                            <Tbody overflow="hidden" whiteSpace="pre-wrap"  textAlign={'left'} borderBottom={'1px solid #eef1f6'}>
                                {orderData.OrderItem.map((d,i) => {
                                        let tempTenureSeqId = tenureData.filter((x) => x.orderItemSeqId === d.orderItemSeqId)
                                        // #### ek kum aa rha h date // fix this
                                        price = d.unitPrice
                                        endDateCalculation(tenureData[0]?.tenure?.startDate, tempTenureSeqId[0]?.tenure?.tenurePeriodId === "MONTHLY" ? tempTenureSeqId[0]?.months : tempTenureSeqId[0]?.weeks, tempTenureSeqId[0]?.tenure?.tenurePeriodId.toLowerCase())
                                        

                                       
                                    return (
                                        <Tr key={i}>
                                        <Td pl={3} pr={0}>
                                            <Text fontSize={14} fontWeight={'semibold'} color={"gray.500"}>{i + 1}.</Text>
                                        </Td>
                                        <Td  px={0} >
                                        <Flex textAlign={'left'} >
                                            <Box>
                                                <Flex >
                                                    <Text as='span' fontSize={14} fontWeight={'semibold'} color={"gray.500"}>{d.title}</Text>
                                                </Flex>
                                                {/* <Flex >
                                                    <Text as='span' fontSize={14} fontWeight={'semibold'} color={"gray.500"}><Text fontWeight={'semibold'} as="span" color={"gray.600"}>Item</Text> : {d.title}</Text>
                                                </Flex> */}
                                                {/* <Flex wordBreak={'break-all'}>
                                                    <Text fontSize={14}><Text fontWeight={'semibold'} as="span" color={"gray.600"}>Ref</Text> : ----</Text>
                                                </Flex>
                                                <Flex wordBreak={'break-all'}>
                                                    <Text fontSize={14}><Text fontWeight={'semibold'} as="span" color={"gray.600"}>HSN/SAC</Text> : ---- </Text>
                                                </Flex> */}
                                            </Box>
                                        </Flex>
                                        </Td>
                                        {/* Item price */}
                                        <Td fontSize={'12px'} px={2} fontWeight={'semibold'} color={"gray.500"} >₹{Number(orderAmount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Td>
                                        {/* Discount */}
                                        <Td fontSize={'12px'} px={2} fontWeight={'semibold'} color={"gray.500"}>₹{
                                            d.discount !== null ?
                                            Number(d.discount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                            :
                                            <Text as="span" fontWeight={'semibold'} color={"gray.500"}>0.00</Text>
                                        }</Td>
                                        {/* Taxable Value */}
                                         <Td fontSize={'12px'} px={2} textAlign={'center'} fontWeight={'semibold'} color={"gray.500"}>₹{
                                            // exclusive tax ( (0.18) * (Number(orderAmount) - (Number(orderAmount - (Number(orderAmount) - ((Number(orderAmount) * (Number(d.discount)/100)))))))).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                            // exclusive tax
                                            Number(Number(orderAmount - d.discount) * 0.18).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                        }</Td>
                                         {/* IGST */}
                                        <Td fontSize={'12px'} px={2} textAlign={'center'} fontWeight={'semibold'} color={"gray.500"}>₹0 <br/>(0%)</Td>
                                        {/* CGST */}
                                        <Td fontSize={'12px'} px={2} textAlign={'center'} fontWeight={'semibold'} color={"gray.500"}>₹{
                                             Number((Number(orderAmount - d.discount) * 0.18) / 2).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                        } <br/>(9%)</Td>
                                        {/* SGST */}
                                        <Td fontSize={'12px'} px={2} textAlign={'center'} fontWeight={'semibold'} color={"gray.500"}>₹{
                                             (Number(Number(orderAmount - d.discount) * 0.18)/ 2).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                        }<br/>(9%)</Td>
                                        {/* Subtotal
                                        <Td fontSize={'12px'} px={2} fontWeight={'semibold'} color={"gray.500"}>₹{
                                            // (Item price - discount Amount = after discount item price) + (18% GST * (Item price - discount Amount) = GST amount) == subtotal
                                            ((Number(orderAmount) - ((Number(orderAmount) * (Number(d.discount)/100)))) + (0.18) * (Number(orderAmount) - (Number(orderAmount - (Number(orderAmount) - ((Number(orderAmount) * (Number(d.discount)/100)))))))).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                        }</Td> */}
                                        {/* Security Deposit */}
                                        {/* <Td fontSize={'12px'} px={2} fontWeight={'semibold'} color={"gray.500"}>₹{
                                        Number(d.refundableDeposit).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                        }</Td> */}
                                        {/* Netpayable */}
                                        <Td fontSize={'12px'} px={2} pr={0} textAlign={'right'} fontWeight={'semibold'} color={"gray.500"}>₹{
                                            (((Number(orderAmount) - d.discount))  + Number(Number(orderAmount - d.discount) * 0.18)).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})
                                        }</Td>
                                    </Tr>
                                    )
                                })}
                               
                            </Tbody>
                         
                        </Table>
                    </TableContainer>
                </Box>
                {/* Net Payable Amount */}
                <Card p={4} mt={5} textAlign={'right'} bgColor={'#e54949'} style={{ pageBreakInside: 'avoid' }} >
                    <CardBody>
                        <Text color={'white'} fontSize={24} fontWeight={'semibold'}>₹{(finalAmountCalObj?.subTotal + finalAmountCalObj?.totalTax).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</Text>
                        <Text color={'white'} fontSize={24} fontWeight={'semibold'}>Net Payable</Text>
                        <Text color={'white'} >Net Payable (In Words) :&nbsp; 
                            <Text as="span">{toWords.convert(Number(finalAmountCalObj?.subTotal + finalAmountCalObj?.totalTax), { currency: true })}</Text>
                        </Text>
                    </CardBody>
                </Card>

                {/* Certified */}
                <Card mt={5} bgColor={'blackAlpha.50'} py={10} px={5} style={{ pageBreakInside: 'avoid' }}>
                    <CardBody>
                        <Flex justifyContent={'space-evenly'}>
                        <Text fontWeight={'bold'} color={"gray.600"} p={3}>Certfied that the Particulars given above are true and correct and the amount indicated.</Text>
                        <Avatar name='Stamp'/>
                        </Flex>
                    </CardBody>
                </Card>
            </Box>           
        </Box>
        <style>
          {`@page {
            size: auto;
            margin: 1cm;
            @top-center {
              content: "Date: " counter(page);
            }
        }
            }`}
        </style>
    </Box>
  )
}

export default OrderInvoice